/** @jsxImportSource @emotion/react */
import { Box, IconButton, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useReducerAtom } from 'jotai/utils';
import { chatListReducer } from '../../../states/chat-list-reducer';
import Searchbar from './searchbar';
import ChatHeaderMain from './header-main';
import { SUBHEADER_HEIGHT } from '../../../../../../shared/typings';
import { chatListAtom, selectedChatIdsListAtom, toggleSelectedChatIdsAtom } from '../../../states/chat-list';
import { useIsStandardPlanWithRestrictedSearch } from '../../../../../../shared/hooks/plan-utils';
import MediaViewerCloseIcon from '../../../../../../shared/icons/MediaViewerClose';

interface ChatListHeaderProps {
  forwardMsgView?: boolean;
  setOpenModalState?: React.Dispatch<React.SetStateAction<boolean>>;
  showLoading?: boolean;
}

const ChatListHeader: React.FC<ChatListHeaderProps> = ({ forwardMsgView, setOpenModalState, showLoading }) => {
  const [state] = useReducerAtom(chatListAtom, chatListReducer);
  const toggleSelectedChatIds = useAtomValue(toggleSelectedChatIdsAtom);
  const selectedChatIdsList = useAtomValue(selectedChatIdsListAtom);
  const isStandardPlanWithRestrictedSearch = useIsStandardPlanWithRestrictedSearch();
  const placeholder = isStandardPlanWithRestrictedSearch ? 'Search chat... (Min 3 char.)' : 'Search... (Min 3 char.)';

  const renderHeader = () => {
    if (forwardMsgView) {
      return (
        <Box display={'flex'} flexDirection={'column'}>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            width={'100%'}
            height={'100%'}
            bgcolor={'#3F906D'}
            minHeight={'60px'}
            color={'#ffffff'}
            paddingLeft={'12px'}
            paddingRight={'12px'}
          >
            <Typography fontSize={16} fontWeight={'500'}>
              Forward message to
            </Typography>
            <IconButton onClick={() => setOpenModalState?.(false)}>
              <MediaViewerCloseIcon width={20} height={20} opacity={1} />
            </IconButton>
          </Box>

          <Box p={'12px'}>
            <Searchbar
              placeholder="Search by customer name or number"
              forwardMsgView={true}
              customCSS={{
                backgroundColor: '#ffffff',
                border: '1px solid #e0e0e9',
                borderRadius: '4px',
                padding: '2px 8px',
              }}
            />
          </Box>
        </Box>
      );
    }
    if (!state.isSearchActive) {
      return <ChatHeaderMain showLoading={showLoading} />;
    }
    if (state.isSearchActive) {
      return <Searchbar showLoading={showLoading} placeholder={placeholder} />;
    }
  };

  const getParentBoxPadding = () => {
    if (forwardMsgView) {
      return '0px';
    }
    if (state.isSearchActive) {
      return '0px 12px 0px 16px';
    } else {
      if (toggleSelectedChatIds) {
        return '0px 8px 0px 16px';
      } else {
        return '0px 12px 0px 16px';
      }
    }
  };

  return (
    <Box
      sx={{
        height: `${SUBHEADER_HEIGHT}px`,
        width: '100%',
        padding: getParentBoxPadding(),
        borderBottom: '1px solid rgba(224, 224, 234, 1)',
      }}
    >
      {renderHeader()}
    </Box>
  );
};

export default ChatListHeader;
